import { useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useCartContext } from '../context/CartContext';
import { ESTIMATE_SHIPPING_METHODS } from '../queries/cart';

const useEstimateShippingMethods = () => {
  const { cart } = useCartContext();
  const { address } = cart;
  const [shippingMethods, setShippingMethods] = useState([]);

  const [fetchShippingMethods, queryResult] = useLazyQuery(ESTIMATE_SHIPPING_METHODS, {
    ssr: false,
    fetchPolicy: 'cache-and-network',
    variables: {
      address: address && {
        countryId: address.country.code,
        postcode: address.postcode,
        city: address.city,
      },
    },
  });

  useEffect(() => {
    fetchShippingMethods();
  }, [address, fetchShippingMethods]);

  useEffect(() => {
    if (queryResult.data) {
      setShippingMethods(queryResult.data.estimateShippingMethods || []);
    }
  }, [queryResult.data]);

  return {
    shippingMethods,
    loading: queryResult.loading,
    error: queryResult.error,
  };
};

export default useEstimateShippingMethods;
